// extracted by mini-css-extract-plugin
export default {"container":"styles_container__rwNvu","card":"styles_card__7w+w1","show":"styles_show__B67iP","header":"styles_header__9FCmj","iconClose":"styles_iconClose__rVd9v"};